import React, { useEffect, useRef, useState } from "react";

import "./formstyle.css";
import "./globalstylesheet-sai.css";
import "./globalstylesheet.css";
import { Link } from "react-router-dom";
import PrivacyPolicy from "containers/PrivacyPolicy";
import TermsAndConditions from "containers/TermsAndConditions";
import { APIRouteConstants } from "constants/routeConstants";
import instance from "configs/axiosConfig";
import { useSelector } from "react-redux";
import { Divider, Container, Box, Typography, Grid } from "@mui/material";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import InappropriateContent from "containers/InappropriateContent";
import { useFooterVisibility } from "Context/FooterContext";

function NewFooter() {
  const { webDetails } = useSelector((state) => state);
  const colors = {
    footer_bg: webDetails?.websiteInfo?.footer_bg
      ? webDetails?.websiteInfo?.footer_bg
      : "#000",
    footer_text: webDetails?.websiteInfo?.footer_text
      ? webDetails?.websiteInfo?.footer_text
      : "#fff",
  };
  const [loading, setLoading] = useState(false);
  const [socialmedia, setSocialmedia] = useState({});
  const [termsOpen, setTermsOpen] = useState(false);
  const [isOpenPrivacy, setOpenPrivacy] = useState(false);
  const [isOpenTerms, setOpenTerms] = useState(false);
  const [header_text, setHeader_text] = useState("");

  const openPrivacyPolicy = (value) => setOpenPrivacy(value);

  const handleTermsOpen = (e) => {
    e.stopPropagation();
    setTermsOpen(true);
  };

  const handleTermsClose = (e) => {
    e.stopPropagation();
    setTermsOpen(false);
  };

  const openTermsAndConditions = (value, e) => {
    setHeader_text(e);
    setOpenTerms(value);
  };

  const getContactinfo = async () => {
    setLoading(true);
    try {
      let res = await instance.get(APIRouteConstants.DASHBOARD.CONTACT_INFO);
      let { data } = res;
      if (data) setSocialmedia(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getContactinfo();
  }, []);

  const isColorTrue = Object.keys(colors).length > 0;
  const { setFooterRef } = useFooterVisibility();
  const footerRef = useRef(null);

  useEffect(() => {
    if (footerRef.current) setFooterRef(footerRef);
  }, [footerRef, setFooterRef]);

  const ftColor = isColorTrue ? colors.footer_text : "#fff";

  const iconCircle = {
    width: 38,
    height: 38,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: ftColor,
    fontSize: "17px",
    flexShrink: 0,
    transition: "opacity 0.2s",
    "&:hover": { opacity: 0.7 },
  };

  const bottomLinks = [
    {
      label: "Privacy Policy",
      onClick: (e) =>
        openTermsAndConditions(e, "Terms of Services and Privacy Policy"),
    },
    {
      label: "Terms & Conditions",
      onClick: (e) =>
        openTermsAndConditions(e, "Terms of Services and Privacy Policy"),
    },
    { label: "Returns & Refunds", onClick: openPrivacyPolicy },
    { label: "T&C - Report inappropriate content", onClick: handleTermsOpen },
  ];

  const navLinkStyle = {
    fontFamily: "Inter, sans-serif, Arial",
    fontSize: "15px",
    color: ftColor,
    opacity: 0.85,
    textDecoration: "none",
  };

  return (
    <footer
      ref={footerRef}
      className="footer"
      style={{ background: isColorTrue && colors.footer_bg }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <Divider sx={{ background: ftColor, opacity: 0.3 }} />

          {/* ── Main row: store info | social | trust badges ── */}
          <Grid
            container
            spacing={{ xs: 2, md: 0 }}
            alignItems={{ md: "center" }}
            sx={{ py: { xs: 3, md: 4 } }}
          >
            {/* Store name + description + About Us + Contact Us */}
            <Grid item xs={6} sm={6} md={4}>
              <Typography
                sx={{
                  fontFamily: "Inter, sans-serif, Arial",
                  fontSize: { xs: "14px", md: "18px" },
                  fontWeight: 700,
                  color: ftColor,
                  mb: 0.8,
                }}
              >
                {webDetails?.websiteInfo?.store_name}
              </Typography>
              {webDetails?.websiteInfo?.description && (
                <Typography
                  sx={{
                    fontFamily: "Inter, sans-serif, Arial",
                    fontSize: { xs: "11px", md: "15px" },
                    color: ftColor,
                    opacity: 0.75,
                    lineHeight: 1.6,
                    mb: 1.2,
                    display: { xs: "none", sm: "block" },
                  }}
                >
                  {webDetails.websiteInfo.description}
                </Typography>
              )}
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.6 }}>
                <Link
                  to="/about"
                  style={{
                    ...navLinkStyle,
                    fontSize: "13px",
                  }}
                >
                  About Us
                </Link>
                <Link
                  to="/contact"
                  style={{
                    ...navLinkStyle,
                    fontSize: "13px",
                  }}
                >
                  Contact Us
                </Link>
              </Box>
            </Grid>

            {/* Connect with us + social icons */}
            <Grid item xs={6} sm={6} md={2}>
              <Typography
                sx={{
                  fontFamily: "Inter, sans-serif, Arial",
                  fontSize: { xs: "13px", md: "15px" },
                  fontWeight: 600,
                  color: ftColor,
                  mb: 1.2,
                }}
              >
                Connect with us
              </Typography>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                {socialmedia?.instagram && (
                  <a
                    href={`https://www.instagram.com/${socialmedia.instagram}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <Box sx={iconCircle}>
                      <i className="bi bi-instagram" />
                    </Box>
                  </a>
                )}
                {socialmedia?.facebook && (
                  <a
                    href={`https://facebook.com/profile.php?id=${socialmedia.facebook}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <Box sx={iconCircle}>
                      <i className="bi bi-facebook" />
                    </Box>
                  </a>
                )}
                {socialmedia?.tiktok && (
                  <a
                    href={`https://www.tiktok.com/@${socialmedia.tiktok}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <Box sx={iconCircle}>
                      <i className="bi bi-tiktok" />
                    </Box>
                  </a>
                )}
                {socialmedia?.linkedIn && (
                  <a
                    href={`https://www.linkedin.com/in/${socialmedia.linkedIn}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <Box sx={iconCircle}>
                      <i className="bi bi-linkedin" />
                    </Box>
                  </a>
                )}
                {socialmedia?.twitter && (
                  <a
                    href={`https://twitter.com/intent/user?user_id=${socialmedia.twitter}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <Box sx={{ ...iconCircle, padding: "10px" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        fill={ftColor}
                        width="15"
                        height="15"
                      >
                        <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
                      </svg>
                    </Box>
                  </a>
                )}
              </Box>
            </Grid>

            {/* Trust badges */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                borderLeft: { md: `1px solid rgba(128,128,128,0.3)` },
                pl: { md: 2 },
                pt: { xs: 1, md: 0 },
              }}
            >
              <Grid container spacing={{ xs: 1, md: 2 }} sx={{ pl: { md: 2 } }}>
                {[
                  {
                    icon: (
                      <GppGoodOutlinedIcon
                        sx={{
                          fontSize: { xs: 18, md: 30 },
                          color: ftColor,
                          opacity: 0.85,
                          flexShrink: 0,
                        }}
                      />
                    ),
                    label: "Secure Payments",
                  },
                  {
                    icon: (
                      <LockOutlinedIcon
                        sx={{
                          fontSize: { xs: 18, md: 30 },
                          color: ftColor,
                          opacity: 0.85,
                          flexShrink: 0,
                        }}
                      />
                    ),
                    label: "Your Data is Protected",
                  },
                  {
                    icon: (
                      <CreditCardOutlinedIcon
                        sx={{
                          fontSize: { xs: 18, md: 30 },
                          color: ftColor,
                          opacity: 0.85,
                          flexShrink: 0,
                        }}
                      />
                    ),
                    label: "Multiple Payment Options",
                  },
                ].map(({ icon, label }) => (
                  <Grid item xs={4} sm={4} md={4} key={label}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: { xs: 0.5, md: 1 },
                      }}
                    >
                      {icon}
                      <Typography
                        sx={{
                          fontFamily: "Inter, sans-serif, Arial",
                          fontSize: { xs: "10px", md: "14px" },
                          color: ftColor,
                          opacity: 0.8,
                          fontWeight: 500,
                          lineHeight: 1.4,
                        }}
                      >
                        {label}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>

          {/* ── Bottom bar ── */}
          <Divider sx={{ background: ftColor, opacity: 0.3 }} />
          <Box
            sx={{
              py: { xs: 2, sm: 1.8 },
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "flex-start", sm: "center" },
              justifyContent: "space-between",
              gap: { xs: 1.5, sm: 0 },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter, sans-serif, Arial",
                fontSize: "13px",
                color: ftColor,
                opacity: 0.8,
                textAlign: "left",
                whiteSpace: { xs: "normal", sm: "nowrap" },
                flexShrink: 0,
              }}
            >
              {`© 2026 ${webDetails?.websiteInfo?.store_name}. All rights reserved.`}
            </Typography>

            {/* xs/sm: 2-col x 2-row grid  |  md+: single flex row with pipes */}
            <Box
              sx={{
                display: { xs: "grid", sm: "grid", md: "flex" },
                gridTemplateColumns: "auto auto",
                gap: { xs: "8px 16px", sm: "8px 20px" },
                alignItems: "center",
                justifyContent: {
                  xs: "flex-start",
                  sm: "flex-start",
                  md: "flex-end",
                },
                flexWrap: "nowrap",
              }}
            >
              {bottomLinks.map(({ label, onClick, to }, i, arr) => (
                <React.Fragment key={label}>
                  {to ? (
                    <Link to={to} style={{ textDecoration: "none" }}>
                      <Box
                        component="span"
                        sx={{
                          fontFamily: "Inter, sans-serif, Arial",
                          fontSize: "1px",
                          color: ftColor,
                          opacity: 0.8,
                        }}
                      >
                        {label}
                      </Box>
                    </Link>
                  ) : (
                    <Box
                      component="span"
                      onClick={onClick}
                      sx={{
                        fontFamily: "Inter, sans-serif, Arial",
                        fontSize: "13px",
                        color: ftColor,
                        opacity: 0.7,
                        cursor: "pointer",
                        "&:hover": { opacity: 1 },
                      }}
                    >
                      {label}
                    </Box>
                  )}
                  {/* pipes only on md+ flex row */}
                  {i < arr.length - 1 && (
                    <Box
                      component="span"
                      sx={{
                        display: { xs: "none", sm: "none", md: "inline" },

                        color: ftColor,
                        opacity: 0.4,
                        fontSize: "14px",
                        userSelect: "none",
                      }}
                    >
                      |
                    </Box>
                  )}
                </React.Fragment>
              ))}
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: { xs: "block", md: "none" }, py: 2 }}>
          {/* Store */}
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 700,
              color: ftColor,
              mb: 1,
            }}
          >
            {webDetails?.websiteInfo?.store_name || "Demo Cafe"}
          </Typography>

          {/* ✅ ADD THIS (About + Contact) */}
          <Box
            sx={{ display: "flex", flexDirection: "column", gap: 0.5, mb: 1.5 }}
          >
            <Link
              to="/about"
              style={{
                color: ftColor,
                fontSize: "13px",
                textDecoration: "none",
                opacity: 0.85,
              }}
            >
              About Us
            </Link>

            <Link
              to="/contact"
              style={{
                color: ftColor,
                fontSize: "13px",
                textDecoration: "none",
                opacity: 0.85,
              }}
            >
              Contact Us
            </Link>
          </Box>
          {/* Connect */}
          <Typography sx={{ fontSize: "14px", color: ftColor, mb: 1 }}>
            Connect with us
          </Typography>

          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            {socialmedia?.instagram && (
              <a
                href={`https://www.instagram.com/${socialmedia.instagram}`}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Box sx={iconCircle}>
                  <i className="bi bi-instagram" />
                </Box>
              </a>
            )}
            {socialmedia?.facebook && (
              <a
                href={`https://facebook.com/profile.php?id=${socialmedia.facebook}`}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Box sx={iconCircle}>
                  <i className="bi bi-facebook" />
                </Box>
              </a>
            )}
            {socialmedia?.tiktok && (
              <a
                href={`https://www.tiktok.com/@${socialmedia.tiktok}`}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Box sx={iconCircle}>
                  <i className="bi bi-tiktok" />
                </Box>
              </a>
            )}
            {socialmedia?.linkedIn && (
              <a
                href={`https://www.linkedin.com/in/${socialmedia.linkedIn}`}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Box sx={iconCircle}>
                  <i className="bi bi-linkedin" />
                </Box>
              </a>
            )}
            {socialmedia?.twitter && (
              <a
                href={`https://twitter.com/intent/user?user_id=${socialmedia.twitter}`}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Box sx={{ ...iconCircle, padding: "10px" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    fill={ftColor}
                    width="15"
                    height="15"
                  >
                    <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
                  </svg>
                </Box>
              </a>
            )}
          </Box>

          <Divider sx={{ background: ftColor, opacity: 0.2, mb: 2 }} />

          {/* TRUST ICONS (HORIZONTAL) */}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            {[
              { icon: <GppGoodOutlinedIcon />, label: "Secure Payments" },
              { icon: <LockOutlinedIcon />, label: "Your Data is Protected" },
              {
                icon: <CreditCardOutlinedIcon />,
                label: "Multiple Payment Options",
              },
            ].map((item, i) => (
              <Box
                key={i}
                sx={{
                  flex: 1,
                  textAlign: "center",
                  px: 1,
                  position: "relative",
                }}
              >
                {/* Icon */}
                <Box sx={{ color: ftColor }}>{item.icon}</Box>

                {/* Text */}
                <Typography
                  sx={{
                    fontSize: "12px",
                    mt: 0.5,
                    lineHeight: 1.3,
                    whiteSpace: "normal",
                    wordBreak: "keep-all",
                    color: ftColor, // 👈 applied
                  }}
                >
                  {item.label}
                </Typography>

                {/* Divider */}
                {i !== 2 && (
                  <Box
                    sx={{
                      position: "absolute",
                      right: 0,
                      top: "20%",
                      height: "60%",
                      width: "1px",
                      backgroundColor: `${ftColor}55`, // 👈 soft divider
                    }}
                  />
                )}
              </Box>
            ))}
          </Box>
          <Divider sx={{ background: ftColor, opacity: 0.2, mb: 1 }} />

          {/* LINKS LIST */}
          {bottomLinks.map(({ label, onClick }) => (
            <Box
              key={label}
              onClick={onClick}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: `1px solid rgba(255,255,255,0.2)`,
                py: 1.5,
                color: ftColor,
              }}
            >
              <Typography sx={{ fontSize: "14px" }}>{label}</Typography>
              <span style={{ fontSize: "14px" }}>›</span>
            </Box>
          ))}

          {/* COPYRIGHT */}
          <Typography
            sx={{
              fontSize: "12px",
              color: ftColor,
              opacity: 0.7,
              mt: 2,
            }}
          >
            © 2026 {webDetails?.websiteInfo?.store_name}. All rights reserved.
          </Typography>
        </Box>
      </Container>

      <PrivacyPolicy
        isOpen={isOpenPrivacy}
        openPrivacyPolicy={openPrivacyPolicy}
      />
      <TermsAndConditions
        isOpen={isOpenTerms}
        setHeader_text={header_text}
        openTermsAndConditions={openTermsAndConditions}
      />
      <InappropriateContent
        termsOpen={termsOpen}
        handleTermsClose={handleTermsClose}
      />
    </footer>
  );
}

export default NewFooter;
